export default function Footer() {
    return (
      <footer className="w-full bg-black text-white text-center py-4 mt-10 fixed bottom-0 left-0">
        <p className="text-sm">© 2024 WordToken Converter. All rights reserved.</p>
      </footer>
    );
  }
  